export default __webpack_public_path__ + "static/media/LocationFill.4139c5fc.svg";